import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import { PronosticoAireInterface, PronosticoAireService } from '@/domain/services/PronosticoAireService'
import { PronosticoAireState, StoreError } from '@/store/modules/pronostico-aire/types'

const PronosticoAire: PronosticoAireInterface = new PronosticoAireService()

export const actions: ActionTree<PronosticoAireState, RootState> = {
  async getPronosticoAire ({ commit }) {
    try {
      const actionResponse = await PronosticoAire.getPronosticoAire()
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  deletePronosticoAire ({ commit }) {
    return commit('PRONOSTICO_AIRE_DELETED', undefined)
  }
}
